/* PlanJapon V2 — bootstrap animations (GSAP + révélations + filet de sécurité).
   Les sections poussent leurs inits dans window.PJ.q ; exécutées ici, après le chargement de GSAP. */
(function () {
  window.PJ = window.PJ || { q: [] };
  var MOTION = document.documentElement.classList.contains('motion');
  var GS = MOTION && !!window.gsap;

  if (GS) {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.batch('.reveal', {
      start: 'top 88%',
      onEnter: function (b) { gsap.to(b, { opacity: 1, y: 0, duration: .7, stagger: .09, ease: 'power3.out', overwrite: 'auto' }); }
    });
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (e) { e.classList.remove('reveal'); });
  }

  /* File d'attente des sections */
  var pending = PJ.q;
  PJ.q = { push: function (f) { try { f(GS); } catch (e) {} } };
  pending.forEach(function (f) { try { f(GS); } catch (e) {} });

  /* Animations infinies EN PAUSE HORS ÉCRAN (2026-09-23).
     Mur d'avis, bandeau des créateurs, orbite des apps, vagues de la carte,
     colonnes de vidéos, stickers : aucune ne s'arrêtait quand on ne la voyait
     plus. Mesuré sur un téléphone moyen simulé : 22 à 28 % du processeur occupé
     EN PERMANENCE en haut de page, sans rien toucher — 1 % sans elles.
     Chaque section est observée ; hors écran, ses tweens GSAP infinis et ses
     animations CSS sont suspendus, et reprennent là où ils en étaient 150 px
     avant de revenir à l'écran. La timeline globale est interrogée à chaque
     bascule, pas figée au départ : les tweens nés plus tard (vagues de la carte,
     créées au défilement) sont donc pris aussi. */
  if ('IntersectionObserver' in window) {
    var css = document.createElement('style');
    css.textContent = '.pj-offscreen *,.pj-offscreen *::before,.pj-offscreen *::after{animation-play-state:paused!important}';
    document.head.appendChild(css);
    var infinis = function (sec) {
      if (!window.gsap) return [];
      return gsap.globalTimeline.getChildren(true, true, false).filter(function (t) {
        if (!t.targets || t.repeat() !== -1) return false;
        var cibles = t.targets();
        for (var i = 0; i < cibles.length; i++) {
          if (cibles[i] && cibles[i].nodeType === 1 && sec.contains(cibles[i])) return true;
        }
        return false;
      });
    };
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        var vu = e.isIntersecting;
        e.target.classList.toggle('pj-offscreen', !vu);
        infinis(e.target).forEach(function (t) { if (vu) t.resume(); else t.pause(); });
      });
    }, { rootMargin: '150px 0px' });
    document.querySelectorAll('.shopify-section').forEach(function (s) { io.observe(s); });
  }

  /* Filet : si rAF gelé (onglet en arrière-plan), état final forcé à 3,2 s */
  setTimeout(function () {
    document.querySelectorAll('.reveal').forEach(function (el) {
      if (getComputedStyle(el).opacity === '0') {
        el.classList.remove('reveal');
        if (window.gsap) gsap.set(el, { clearProps: 'opacity,transform' });
        else { el.style.opacity = ''; el.style.transform = ''; }
      }
    });
  }, 3200);
})();
